module.exports = __webpack_public_path__ + "static/media/scott84.b22bb595.png";